import * as constants from './constants';

export const setLoading = (type: string, value: boolean) => ({
  type: constants.SET_LOADING,
  payload: {
    type,
    value,
  },
});

export const setIsShowBottomBar = (isShowBottomBar: boolean) => ({
  type: constants.SET_IS_SHOW_BOTTOM_BAR,
  payload: {
    isShowBottomBar,
  },
});

export const setIsBatchSelect = (isBatchSelect: boolean) => ({
  type: constants.SET_IS_BATCH_SELECT,
  payload: {
    isBatchSelect,
  },
});
